<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg12>
          <v-card pa-0>
            <v-toolbar card color="white">
              <v-text-field
              flat
              solo
              prepend-icon="search"
              placeholder="Type something"
              v-model="search"
              hide-details
              @click:prepend="showFilter = !showFilter"
              @input="searchTerm"
              ></v-text-field>     
              <!--<v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>-->                           
              <!--<v-btn color="blue" @click="save()" dark>
                <v-icon>save</v-icon> Simpan
              </v-btn>-->  
                          
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text v-if="showFilter">
              <v-layout>
                <v-flex md6 xs12>
                  <v-btn-toggle class="mr-3" v-model="toggle_gender" multiple dark>
                    <v-btn small flat class="red white--text" :value="1">L</v-btn>
                    <v-btn small flat class="blue-grey white--text"  :value="2">P</v-btn>              
                  </v-btn-toggle>  
                  <v-btn-toggle v-model="toggle_tingkat" class="mr-3" multiple dark>                
                    <v-btn round small v-for="(tingkat,i) in tingkats" :key="i" :value="tingkat.id" :color="getColor(tingkat.id)">{{tingkat.nama}}</v-btn>                
                  </v-btn-toggle> 
                </v-flex>        
              </v-layout>  
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text class="pa-0 tabular">
              <v-data-table                
                :headers="complex.headers"
                :items="complex.items"
                :loading="complex.loading"
                :pagination.sync="complex.options"
                :rows-per-page-items="[{text:'All','value':-1}]"
                hide-actions                
                >
                <template slot="items" slot-scope="props">
                  <td>{{ ((complex.pagination.currentPage-1)*20)+(props.index+1) }}</td>   
                  <td>{{props.item.id}}</td>                                
                  <!--<td>{{ props.item.calon.user_id }}</td>-->
                  <td style="min-width:190px">{{ props.item.nama }} ({{props.item.gender === 1?'L':'P'}})</td>
                  <td>{{ props.item.telepon }}</td>  
                  <td v-if="tingkats.length > 0">{{ tingkats.find(x=>x.id===props.item.jurusan_id) ? tingkats.find(x=>x.id===props.item.jurusan_id).description : tingkats.find(x=>x.id===props.item.tingkat_id).description}}</td>
                  <!--<td>{{ props.item.lahir_tempat +', '+ $moment(props.item.lahir_tanggal).format('DD/MM/YYYY') }}</td>-->
                  <td>{{props.item.ayah_nama}}</td>
                  <td>{{props.item.ibu_nama}}</td>
                  <template v-if="props.item.calonTest">
                    <td>{{props.item.calonTest.quran1?props.item.calonTest.quran1:'-'}}</td>
                    <td>{{props.item.calonTest.quran2?props.item.calonTest.quran2:'-'}}</td>      
                    <td><v-chip dark :color="getQuranWarna(props.item.calonTest.quran)" v-if="props.item.calonTest.quran !== null && props.item.calonTest.quran !== undefined">
                      {{getQuranStatus(props.item.calonTest.quran)}}
                      </v-chip>
                    </td>
                  </template>
                  <template v-else>
                    <td>-</td><td>-</td><td>-</td>
                  </template>
                </template>
              </v-data-table>
              <v-divider/>
              <div class="text-xs-center pa-2">
                <v-pagination
                  v-model="complex.pagination.currentPage"
                  :length="complex.pagination.pageCount"
                  :total-visible="9"
                ></v-pagination>
              </div>
            </v-card-text>            
          </v-card>
        </v-flex>                           
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import { debounce } from 'lodash'
import Model from '@/apps/admin/models/Calon';   
const  model = new Model();

export default {
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({
        search   : '',
        loading  : true,
        toggle_tingkat : [],
        toggle_gender : [],
        pagination: {},
        complex  : {
            selected: [],
            headers: [
              { text: '#',   value: 'no'  },
              { text: 'ID',   value: 'id'  },
              { text: 'Nama', value: 'nama'},              
              { text: 'Telepon', value: 'telepon'}, 
              { text: 'Tingkat', value: 'tingkat_id'}, 
              { text: 'Nama Ayah', value: 'ayah_nama'}, 
              { text: 'Nama Ibu', value: 'ibu_nama'}, 
              { text: 'Tes 1', value:'calonTest.quran1'},
              { text: 'Tes 2', value:'calonTest.quran2'},
              { text: 'Quran', value:'calonTest.quran'},
            ],
            items: [],
            options : {},
            loading : false,
            pagination:{
              totalCount: null,
              pageCount: 0,
              currentPage: 1,
              perPage: 20
            },
        },
        loadingDownload : false,
        tingkats : [],
        status   : [],
        types    : [],
        data     : [],
        showFilter : false
    }),  
    watch:{
      toggle_tingkat(newArr){
        let tingkat = [], jurusan = [];
        newArr.forEach(ar=>{
          if(ar <= 3){tingkat.push(ar);} 
          else if(ar === 7){tingkat.push(ar);}
          else{jurusan.push(ar);}
        });                
        this.init(this.complex.pagination.currentPage, this.toggle_gender, tingkat, jurusan);        
      },
      toggle_gender(newArr){                
        this.init(this.complex.pagination.currentPage, newArr, this.filter.tingkat, this.filter.jurusan);        
      },
      'complex.pagination.currentPage'(newPage){        
        this.init(newPage, this.toggle_gender, this.filter.tingkat, this.filter.jurusan) 
      },
      'complex.options':{
        handler(){          
          this.init(this.complex.pagination.currentPage, this.toggle_gender, this.filter.tingkat, this.filter.jurusan)
        }, deep:true      
      },
    },
    computed:{
      filter(){
        let tingkat = [], jurusan = [];
        this.toggle_tingkat.forEach(ar=>{
          if(ar <= 3){tingkat.push(ar);} 
          else if(ar === 7){tingkat.push(ar);}
          else{jurusan.push(ar);}
        });
        return {tingkat: tingkat, jurusan:jurusan};
      }
    },
    mounted(){ 
      model.tingkats().then(data=>{this.tingkats = data});
      model.paymentStatus().then(data=>{this.status = data});
      model.paymentTypes().then(data=>{this.types = data});
      this.init(); 
    },            
    methods: {      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},
        
        getColor(tingkat){
          switch(tingkat){case 1:return 'red darken-2'; case 2: return 'indigo'; case 3:return 'blue-grey'; case 7:return 'light-green'; default:return 'blue-grey';}
        },
        
        getQuranWarna(status){
          switch(status){case 0:return 'yellow darken-2'; case 1: return 'green darken-2'; case -1:return 'orange darken-2'; default:return 'blue-grey';}
        },
        
        getQuranStatus(status){
          switch(status){case 0:return 'mengulang'; case 1: return 'lulus'; case -1:return 'telah mengulang'; default:return '';}
        },
        
        searchTerm:debounce(function (newText) {         
          this.init(this.complex.pagination.currentPage, this.toggle_gender, this.filter.tingkat, this.filter.jurusan)                         
        }, 500),

        init(page = 1, gender='', tingkat='', jurusan_id=''){
          this.complex.loading = true
          let  sortby = this.complex.options.sortBy ? this.complex.options.sortDesc ? 
            '-'+this.complex.options.sortBy : this.complex.options.sortBy : 'id'; 

          const params = {
            perPage: 20,
            page: page,
            expand:'calonTest',
            'UserCalonSearch[nama]': this.search,
            'UserCalonSearch[gender]': gender,
            'UserCalonSearch[tingkat_id]': tingkat,
            'UserCalonSearch[jurusan_id]': jurusan_id,
            sort:sortby,              
          }
          this.complex.items = [];
          model.indexQuran(params).then(res => {      
              this.complex.items = res.data; 
              this.complex.pagination.pageCount = res.pagination.pageCount;  
              this.complex.loading = false;
          });                                         
        },                                                                                        
        
        save(){
          model.saveQuran({data:this.data}).then((res)=>{
            if(res.status === 200){
              this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                              
              this.init();
            }
          });
        },
        
        setData(fm){
          let calonTest = this.data.find(x=>x.calon_id === fm.id);
          if(calonTest){
            calonTest.quran1    = fm.calonTest.quran1;
            calonTest.quran2    = fm.calonTest.quran2;            
          }else{
            this.data.push({calon_id:fm.id, quran1:fm.calonTest.quran1, quran2:fm.calonTest.quran2});
          }
        }
    }
}
</script>
<style>
.v-radio label{font-size:13px}  
.tabular table.v-table tbody td:first-child, .tabular table.v-table tbody td:not(:first-child), .tabular table.v-table tfoot td:first-child, .tabular table.v-table tfoot td:not(:first-child), .tabular table.v-table tbody th:first-child, .tabular table.v-table tbody th:not(:first-child), .tabular table.v-table thead td:first-child, .tabular table.v-table thead td:not(:first-child), .tabular table.v-table thead th:first-child, .tabular table.v-table thead th:not(:first-child) {
    padding: 0 4px;
}
.tabular table.v-table tbody td:first-child, .tabular table.v-table thead th:first-child{
    padding: 0 5px 0 9px
}
</style>